import { ICONS } from "./icons";

export interface MenuV2Item {
  label: string;
  route: string;
  icon: keyof typeof ICONS;
  /** Se true, este item será substituído dinamicamente pelos módulos do usuário */
  isDynamicModule?: boolean;
}

export interface MenuV2Section {
  title: string;
  titleMini: string
  items: MenuV2Item[];
}

// Menu base - os itens de módulo dinâmico serão injetados em runtime
export const MENU_V2: MenuV2Section[] = [
  {
    title: 'administração',
    titleMini: 'ADM',
    items: [
      { label: 'Dashboard', route: '/main/v2/dashboard', icon: 'dashboard' },
      { label: 'Empresas', route: '/main/v2/company', icon: 'company' },
      { label: 'Grupos de Clínicas', route: '/main/v2/clinic-groups', icon: 'clinicGroups' },
      { label: 'Intercorrências', route: '/main/v2/incident-questions', icon: 'incidentQuestions' },
      { label: 'Templates', route: '/main/v2/templates', icon: 'templates' },
      { label: 'Usuários', route: '/main/v2/users', icon: 'users' },
      { label: 'Prestadores', route: '/main/v2/providers', icon: 'providers' },
      { label: 'Procedimentos', route: '/main/v2/procedures', icon: 'procedures' }
    ]
  },
  {
    title: 'operação',
    titleMini: 'OPR',
    items: [
      // Módulo PACIENTES (fixo)
      { label: 'Pacientes', route: '/main/v2/patients', icon: 'patients' },
      { label: 'Anamneses', route: '/main/v2/anamneses', icon: 'anamnesis' },
      { label: 'Assinaturas', route: '/main/v2/signatures', icon: 'signature' },
      { label: 'Planos de Tratamento', route: '/main/v2/treatment-plans', icon: 'treatmentPlan' },
      // Marcador para módulos dinâmicos (serão substituídos em runtime)
      { label: '__DYNAMIC_MODULES__', route: '', icon: 'users', isDynamicModule: true }
    ]
  }
];

/**
 * Gera os itens de menu para um módulo dinâmico
 * @param moduleDescription Nome do módulo (ex: 'ALUNOS', 'TERCEIROS', 'FORNECEDORES')
 */
export function generateModuleMenuItems(moduleDescription: string): MenuV2Item[] {
  const moduleLower = moduleDescription.toLowerCase();
  const moduleCapitalized = moduleDescription.charAt(0).toUpperCase() + moduleDescription.slice(1).toLowerCase();
  
  return [
    { label: moduleCapitalized, route: `/main/v2/modules/${moduleLower}`, icon: 'users' },
    { label: 'Formulários', route: `/main/v2/modules/${moduleLower}/forms`, icon: 'anamnesis' },
    { label: 'Assinaturas', route: `/main/v2/modules/${moduleLower}/signatures`, icon: 'signature' }
  ];
}
